import { Navigate, useParams } from 'react-router-dom';

import DECKS from './decks';

const Deck = () => {
  const { slug } = useParams();
  const deck = DECKS.find((candidate) => candidate.slug === slug);

  if (!deck) {
    return <Navigate to="/presentations" replace />;
  }

  return <deck.component />;
};

export default Deck;
